/**
 * A library operation that could not be carried out, carrying a message
 * meant for the user. `createPlaylist` throws one for a duplicate name,
 * `addToLibrary` for a library that has not loaded yet. Callers show it
 * through the snackbar with `showLibraryErrors` rather than each writing
 * the same try/catch.
 */
export class LibraryError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LibraryError';
  }
}

/**
 * Runs `fn`. A LibraryError is shown through `showMessage` and yields
 * undefined; anything else propagates, since it is a bug and not a message.
 */
export function showLibraryErrors<T>(
  showMessage: (message: string) => void,
  fn: () => T,
): T | undefined {
  try {
    return fn();
  } catch (err) {
    if (err instanceof LibraryError) {
      showMessage(err.message);
      return undefined;
    }

    throw err;
  }
}
